import type { SortOption } from "../types/dashboard.types";

export const SORT_OPTION_VALUES = [
  "updated",
  "name",
  "responses",
  "completion",
  "status",
] as const satisfies readonly SortOption[];

export const SORT_OPTIONS: Array<{ value: SortOption; label: string }> = [
  { value: "updated", label: "Last Updated" },
  { value: "name", label: "Name" },
  { value: "responses", label: "Responses" },
  { value: "completion", label: "Completion" },
  { value: "status", label: "Status" },
];

export const DEFAULT_SORT_BY: SortOption = "updated";
export const DEFAULT_ITEMS_PER_PAGE = 5;
